import { Icon as e } from "../../../components/Icon/index.js";
import { SmartLink as i } from "../../../components/SmartLink/index.js";
import { styled as o } from "styled-components";
import { Colors as n } from "../../../styles/colors/index.js";
import { Theme as t } from "../../../styles/themes/index.js";
import { CaptionLight as l, CaptionHeavy as p } from "../../../styles/typography/index.js";
const g = o.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`, h = o.div`
  ${l}
  color: rgb(${n.Gray});
  margin-right: 3px;
`, x = o(i)`
  ${p}
  text-decoration: none;
  color: rgb(${t.colors.Alpha});

  pointer-events: ${({ disablePointerEvents: r }) => r ? "none" : "all"};
  cursor: ${({ disablePointerEvents: r }) => r ? "default" : "pointer"};

  &:hover {
    color: rgb(${t.colors.Alpha});
    text-decoration: underline;
  }
`, $ = o(e)`
  font-size: 24px;
  color: rgb(${t.colors.Alpha});
  display: flex;
`;
export {
  g as StoreContainer,
  x as StoreLink,
  h as StoreText,
  $ as VerifiedStoreIcon
};
